import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setStore, getStore, removeStore, clearStore, getAllStore } from "@/util/store";
export default {
  name: "store",
  methods: {
    setItem: function setItem() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var name = params.name,
          value = params.value,
          type = params.type;
      setStore({
        name: name,
        content: value,
        type: type
      });
      this.$message("\u8BBE\u7F6E\u6570\u636E ".concat(name, " = ").concat(value));
    },
    getItem: function getItem() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var name = params.name,
          type = params.type;
      var content = getStore({
        name: name,
        type: type
      });
      this.$message("\u83B7\u53D6\u6570\u636E ".concat(name, " = ").concat(content));
    },
    delItem: function delItem() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var name = params.name,
          type = params.type;
      removeStore({
        name: name,
        type: type
      });
      this.$message("\u5220\u9664\u6570\u636E ".concat(name));
    },
    clearAll: function clearAll() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      clearStore(params);
      this.$message("\u6E05\u9664\u5168\u90E8\u6570\u636E\u5B8C\u6210");
    },
    getAll: function getAll() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var list = getAllStore(params);
      window.console.log(list);
      this.$message("\u7ED3\u679C\u5DF2\u7ECF\u6253\u5370\u5230\u63A7\u5236\u53F0");
    }
  }
};